<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>矿工流水</span>
        </div>

        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item label="日期" prop="title">
            <el-date-picker
              v-model="queryParams.start_date"
              type="date"
              placeholder="选择日期"
              size="mini"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="日期" prop="title">
            <el-date-picker
              v-model="queryParams.end_date"
              type="date"
              size="mini"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="用户ID" prop="title">
            <el-input v-model.number="queryParams.uid" size="mini" placeholder="请输入用户ID" @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
          </el-form-item>
        </el-form>

        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="uid"
            label="用户ID"
          />
          <el-table-column
            prop="level"
            label="矿场等级"
          />
          <el-table-column
            prop="required_workers"
            label="雇佣人数"
          />
          <el-table-column
            prop="completion_reward"
            label="建造奖励"
          />
          <el-table-column
            prop="speedup_cost"
            label="加速消耗"
          />
          <el-table-column
            prop="has_speedup"
            label="加速"
          >
            <template v-slot:default="scope">
              {{ scope.row.has_speedup === 1 ? "是":"否" }}
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getMiningRecord } from '@/api/config/reward-record'
import { getCacheQuery, getLastDates, setCacheQuery } from '@/utils'

export default {
  name: 'MiningRecord',
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize: 100,
        uid: '',
        start_date: '',
        end_date: ''
      },
      ordersList: [],
      loading: false,
      total: 0,
      options: [],
      tableData: []
    }
  },
  created() {
    const getUid = this.$route.query.uid
    const getDate = this.$route.query.date
    if (getDate) {
      this.queryParams.time = getDate
    }
    if (getUid > 0) {
      this.queryParams.uid = getUid
    }

    if (!this.queryParams.start_date) {
      this.queryParams.start_date = getLastDates(0)
      this.queryParams.end_date = getLastDates(0)
    }

    if (this.queryParams.uid && this.queryParams.start_date) {
      this.handleQuery(undefined)
    }
  },
  methods: {
    handleKeyUp() {
      this.getTables({})
    },
    resetQuery() {
      this.$refs.queryForm.resetFields()
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.time === '') {
        this.msgError('请选择日期')
        return
      }

      if (!this.queryParams.uid) {
        this.msgError('请输入用户ID')
        return
      }

      if (this.queryParams.changeType === 0) {
        this.queryParams.order = ''
      }
      this.getTables({})
    },
    getTables(event) {
      this.loading = true
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getMiningRecord(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.list.data
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
